import { Field, formatQuery, RuleGroupType, RuleType } from 'react-querybuilder'
import { Node } from 'reactflow'

import { NodeStep } from '@ui/__generated__/graphql'
import { NodeStepPredicate } from '@ui/interfaces'

const fromNestedFieldBracketNotationToJSONata = (key: string) => {
  // e.g., resource[service.name] => resource."service.name"
  return key.replace(/\[/g, '."').replace(/\]/g, '"')
}

const fromJSONataToNestedFieldBracketNotation = (key: string) => {
  // e.g., resource."service.name" => resource[service.name]
  return key.replace(/\.\s*"([^"]+)"/g, '[$1]')
}

const isRuleGroupType = (rule: RuleGroupType | RuleType): rule is RuleGroupType => {
  return (rule as RuleGroupType).combinator !== undefined
}

const extractFieldsFromQuery = (ruleGroup: RuleGroupType): string[] => {
  return ruleGroup.rules.flatMap((rule) => {
    if (isRuleGroupType(rule)) {
      return extractFieldsFromQuery(rule)
    } else {
      return fromJSONataToNestedFieldBracketNotation(rule.field)
    }
  })
}

export const toStepPredicate = (ruleGroup: RuleGroupType): NodeStepPredicate => ({
  jsonata: formatQuery(ruleGroup, { format: 'jsonata', parseNumbers: true }),
  fields: extractFieldsFromQuery(ruleGroup),
  ruleGroup,
})

export const extractFieldSetFromStepPredicates = (nodes: Node[]): Set<string> => {
  return new Set(
    nodes.flatMap((node) => {
      if (node.data?.steps?.length) {
        return node.data.steps.flatMap((step: NodeStep) => {
          const predicate = step.predicate as NodeStepPredicate | undefined
          return predicate?.fields || []
        })
      }
      return []
    })
  )
}

// our keys are in the shape of resource[service.name], but we'll need to map this to JSONata resource."service.name"
export const toJSONataTranslatableField = (key: string): Field => ({
  name: fromNestedFieldBracketNotationToJSONata(key),
  label: key,
})
